import { useId } from "react";

import { FLOOR_TEXT_INPUT_CLASS, FreeTextSuggestionInput } from "@/components/ui/FreeTextSuggestionInput";
import { Input } from "@/components/ui/Input";
import { cn } from "@/lib/utils";

export const INBOUND_ARRIVAL_VENDOR_NOT_ON_LIST_LABEL = "Vendor not on list";

export type InboundArrivalVendorMode = "list" | "custom";

export function InboundArrivalVendorField({
  id,
  mode,
  listValue,
  onListValueChange,
  customValue,
  onCustomValueChange,
  suggestions,
  disabled = false,
}: {
  id: string;
  mode: InboundArrivalVendorMode;
  listValue: string;
  onListValueChange: (value: string) => void;
  customValue: string;
  onCustomValueChange: (value: string) => void;
  suggestions: readonly string[];
  disabled?: boolean;
}): JSX.Element {
  const customFieldId = useId();

  if (mode === "list") {
    return (
      <FreeTextSuggestionInput
        id={id}
        value={listValue}
        onChange={onListValueChange}
        placeholder="Who sent this?"
        suggestions={suggestions}
        disabled={disabled}
      />
    );
  }

  return (
    <Input
      id={customFieldId}
      value={customValue}
      onChange={(event) => onCustomValueChange(event.target.value)}
      placeholder="Type the vendor name from the label"
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
      disabled={disabled}
      className={cn(FLOOR_TEXT_INPUT_CLASS, "touch-manipulation")}
    />
  );
}

export function inboundArrivalVendorSubmitValue(input: {
  mode: InboundArrivalVendorMode;
  listValue: string;
  customValue: string;
}): string {
  return input.mode === "custom" ? input.customValue.trim() : input.listValue.trim();
}
